import { render, staticRenderFns } from "./KPIQuestionItem.vue?vue&type=template&id=5a8e836e"
import script from "./KPIQuestionItem.vue?vue&type=script&lang=js"
export * from "./KPIQuestionItem.vue?vue&type=script&lang=js"
import style0 from "./KPIQuestionItem.vue?vue&type=style&index=0&id=5a8e836e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports